"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetDeadlineActionLabel = void 0;
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importDefault(require("react"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
function SetDeadlineActionLabel(props) {
    const { action } = props;
    const config = action === null || action === void 0 ? void 0 : action.workflowActionConfig;
    return (react_1.default.createElement(Text_1.default, null, ' ' + lib_i18n_1.default.t('to') + ' ' +
        ((config === null || config === void 0 ? void 0 : config.duration) || '---') +
        ' ' +
        (config === null || config === void 0 ? void 0 : config.unit) +
        ((config === null || config === void 0 ? void 0 : config.unit) && (config === null || config === void 0 ? void 0 : config.duration) > 1 ? 's' : '')));
}
exports.SetDeadlineActionLabel = SetDeadlineActionLabel;
exports.default = SetDeadlineActionLabel;
